module.exports = __webpack_public_path__ + "img/step-3.dbbf420b.svg";